import React, { useCallback, useEffect, useRef } from 'react';
import ContainerFluid from 'component/ContainerFluid';
import TopBanner from 'component/Home/TopBanner';
import Image from '../../component/ImgComponent';
import classNames from 'classnames';
import TopBannerButton from 'component/Home/TopBannerButton';
import Footer from 'component/Footer';
// import Benefit from 'component/Services/Benefit';
import styles from './Services.module.scss'
import Header from 'component/Header/Header';
import StickyContact from 'component/StickyContact';
import ScrollToTop from 'component/ScrollToTop';
import smoothScroll from 'common/smoothscroll';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { findService, services } from '../../common/services'
import { Check2Square, PlayCircle } from 'react-bootstrap-icons';
import Loading from 'component/Loading';
import Lottie from 'react-lottie';
import HtmlRender from 'component/HtmlRender';
import dynamic from "next/dynamic"

const Benefit = dynamic(
  () => {
    return import("component/Services/Benefit");
  },
  { ssr: false }
);

const ServiceDetail = ({ locale, service, localeServer }) => {
  const router = useRouter()
  // const service = findService(router.query.slug)
  const [ref, inView] = useInView({
    threshold: 0.55,
    triggerOnce: true
  })
  const videoRef = useRef()

  const scrollToDetail = useCallback(() => {
    smoothScroll.scrollTo("service-content-wrapper", undefined, 66)
  }, [])

  const onPlay = () => {
    if(videoRef.current && typeof document !== 'undefined'){
      videoRef.current.play()
      document.querySelector(".play-btn-wrapper").classList.remove("d-flex")
      document.querySelector(".play-btn-wrapper").classList.add("d-none")
    }
  }

  if (!service) {
    return <Loading />
  }
  return (
    <>
      <Head>
        <title>{service.banner.text_title[localeServer]}</title>
        <meta name="description" property="description" content={service.banner.content[localeServer]}></meta>
        <meta prefix="og: http://ogp.me/ns#" name="title" property="og:title" content={service.banner.text_title[localeServer]} key="ogtitle"></meta>
        <meta prefix="og: http://ogp.me/ns#" name="description" property="og:description" content={service.banner.content[localeServer]} key="ogdesc"></meta>
        <meta prefix="og: http://ogp.me/ns#" property="og:type" content="website"></meta>
        <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"/>
        <link rel="prefetch" href="/static/vn-flag.png" />
        <link rel="prefetch" href="/static/uk-flag.png" />
        <meta prefix="og: http://ogp.me/ns#" property="og:url" content={`https://estuary.solutions/${router.localeServer}/${router.asPath}`}></meta>
        <meta prefix="og: http://ogp.me/ns#" name="image" property="og:image" content={typeof window !== "undefined" && window.location.origin + service.banner.image}></meta>
        <link rel="canonical" href={`https://estuary.solutions/${router.localeServer}/${router.asPath}`} />
        <link rel="shortcut icon" href={`${process.env.NEXT_PUBLIC_MEDIA_FILE}299c980f-d8d5-406e-8fe1-432221fa6896`} type="image/x-icon" />
        <meta name="keywords" content={service.banner.text_title[localeServer]} />
        <meta name="google-site-verification" content="6n3Wp03vZ36Noklv85xu6JvwOn7gCydfNscFhpoBDH0" />
      </Head>
      <Header />
      <ContainerFluid>
        <TopBanner
          mode="fill"
          title={service.banner.title[locale]}
          description={
            <HtmlRender>
              {service.banner.content[locale]}
            </HtmlRender>
          }
          actions={
            (mode) => (
              <>
                <TopBannerButton
                  className={classNames("mt-5 mb-3", mode === "fill" && "border-white")}
                  title={locale === "vi" ? "Yêu cầu Demo" : "Request Demo"}
                  link="/contact"
                  message={
                    locale === "vi"
                      ? `Yêu cầu Demo ${service.banner.text_title[locale]}`
                      : `Request Demo ${service.banner.text_title[locale]}`
                  }
                  service_id={service.id}
                />
                <TopBannerButton
                  className={classNames("my-3", mode === "fill" && "border-white")}
                  title={locale === "vi" ? "Chi tiết tính năng" : "Detailed Features"}
                  onClick={scrollToDetail}
                />
              </>
            )
          }
        >
          <div className="col-12 col-md-6 text-center mt-5 mt-lg-0">
            <motion.div
              initial={{
                opacity: 0,
                x: 100
              }}
              animate={{
                opacity: 1,
                x: 0
              }}
              transition={{ duration: 0.8 }}
            >
              <Image width={550} height={355} objectFit="contain" src={typeof window !== "undefined" ? window.location.origin + service.banner.image : service.banner.image} alt="service banner 1" />
            </motion.div>
          </div>
        </TopBanner>
      </ContainerFluid>
      <ContainerFluid ref={ref} className="service-content-wrapper overflow-hidden">
        <div className="container">
          <div className={classNames("row align-items-center", styles.mainDesc)}>
            <div className="col-12">
              <h3
                className={
                  classNames(styles.serviceTitle, "w-100 text-center md-text-size text-dark-blue")
                }
              >
                {service.description.title[locale]}
              </h3>
              <p className="mb-4 text-center w-100 default-text-size">
                <HtmlRender>
                  {service.description.desc_title[locale]}
                </HtmlRender>
              </p>
            </div>
            <motion.div
              className="description-thumb col-12 col-lg-6 text-center"
              initial={{
                x: -500,
                opacity: 0,
                // scaleX: 0,
              }}
              animate={inView && {
                x: 0,
                opacity: 1,
                // scaleX: 1,
              }}
              transition={{
                duration: 0.5,
                bounce: 0.5
              }}
            >
              {service.description?.image &&
                <Image styles={{position: "absolute"}} width={500} height={490} src={typeof window !== "undefined" ? window.location.origin + service.description.image : service.description.image} />
              }
              {
                service.description?.lottieFile?.jsonFile &&
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true, 
                    animationData: service.description?.lottieFile?.jsonFile || undefined,
                    rendererSettings: {
                      preserveAspectRatio: 'xMidYMid slice'
                    }
                  }}
                  width={"100%"}
                />
              }
            </motion.div>
            <motion.div
              className="description-content col-12 col-lg-6 mt-4 mt-lg-0"
              initial={{
                x: "100%",
                opacity: 0,
                // scaleX: 0,
              }}
              animate={inView && {
                x: 0,
                opacity: 1,
                // scaleX: 1,
              }}
              transition={{
                duration: 0.5,
                bounce: 0.5
              }}
            >
              <p dangerouslySetInnerHTML={{ __html: service.description.content[locale] }}>
                {/* {service.description.content[locale]} */}
              </p>
              <div className="check-list-wrapper">
                {
                  service.description.usefull.map((item, index) => {
                    return (
                      <div key={"usefull-" + index} className={classNames("d-flex text-blue", styles.useFullItem)}>
                        <Check2Square style={{ marginTop: "5px" }} />
                        <p className="ml-1 mb-0 pr-0 mr-0 mr-xl-3 pr-xl-3">{item[locale]}</p>
                      </div>
                    )
                  })
                }
              </div>
            </motion.div>
          </div>
        </div>
      </ContainerFluid>
      <ContainerFluid>
        <div className="key-benefit w-100">
          <div className={classNames(styles.keyBenefitLine)}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-3">
                  <h5 className="page-title text-dark-blue text-uppercase">
                    {
                      locale === "vi" ? "Các lợi ích chính" : "Key Benefits"
                    }
                  </h5>
                </div>
                <div className="col-12 col-sm-6 col-lg-4">
                  <Benefit
                    title={service.benefits[0].benefit_title[locale]}
                    description={service.benefits[0].benefit_content[locale]}
                    thumb={service.benefits[0].image}
                    jsonFile={service.benefits[0].jsonFile}
                    jsonSize={service.benefits[0].jsonSize}
                  />
                </div>
                <div className="col-12 col-sm-6 offset-sm-0 col-lg-4 offset-lg-1">
                  <Benefit
                    title={service.benefits[1].benefit_title[locale]}
                    description={service.benefits[1].benefit_content[locale]}
                    thumb={service.benefits[1].image}
                    jsonFile={service.benefits[1].jsonFile}
                    jsonSize={service.benefits[1].jsonSize}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(styles.keyBenefitLine)}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-3"></div>
                <div className="col-12 col-sm-6 col-lg-4">
                  <Benefit
                    title={service.benefits[2].benefit_title[locale]}
                    description={service.benefits[2].benefit_content[locale]}
                    thumb={service.benefits[2].image}
                    jsonFile={service.benefits[2].jsonFile}
                    jsonSize={service.benefits[2].jsonSize}
                  />
                </div>
                <div className="col-12 col-sm-6 offset-sm-0 col-lg-4 offset-lg-1">
                  <Benefit
                    title={service.benefits[3].benefit_title[locale]}
                    description={service.benefits[3].benefit_content[locale]}
                    thumb={service.benefits[3].image}
                    jsonFile={service.benefits[3].jsonFile}
                    jsonSize={service.benefits[3].jsonSize}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(styles.keyBenefitLine)}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-3"></div>
                <div className="col-12 col-sm-6 col-lg-4">
                  <Benefit
                    title={service.benefits[4].benefit_title[locale]}
                    description={service.benefits[4].benefit_content[locale]}
                    thumb={service.benefits[4].image}
                    jsonFile={service.benefits[4].jsonFile}
                    jsonSize={service.benefits[4].jsonSize}
                  />
                </div>
                {service?.benefits[5]?.image &&
                  <div className="col-12 col-sm-6 offset-sm-0 col-lg-4 offset-lg-1">
                    <Benefit
                      title={service.benefits[5].benefit_title[locale]}
                      description={service.benefits[5].benefit_content[locale]}
                      thumb={service.benefits[5].image}
                      jsonFile={service.benefits[5].jsonFile}
                      jsonSize={service.benefits[5].jsonSize}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </ContainerFluid>
      {router.query.slug * 1 === 3 && service.video && service.video?.url?.[locale] &&
        <ContainerFluid>
          <div className={classNames(styles.videoWrapper, "container")}>
            <div className="row">
              <div className="col-12 col-lg-3">
                <h5 className="page-title text-dark-blue">{service.video.title[locale]}</h5>
              </div>
              <div className="col-12 col-lg-9">
                <div style={{position: "relative"}} className={styles.video}>
                  <div 
                    style={{
                      background: "url(/static/video-bg.png) 100% no-repeat",
                      backgroundSize: "cover"
                    }} 
                    className="play-btn-wrapper d-flex align-items-center justify-content-center"
                  >
                    <PlayCircle 
                      className="play-btn"
                      onClick={onPlay}
                    />
                  </div>
                  <video ref={videoRef} width="100%" controls>
                    <source src={service.video.url.[locale]} type="video/mp4"/>
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </ContainerFluid>
      }
      <ContainerFluid>
        <Footer />
      </ContainerFluid>
      <ScrollToTop />
      <StickyContact />
    </>
  );
};

export const getStaticPaths = async (params) => {
  // const res = await getNewsList({
  //   lang_id: params.locale === "vi" ? 1 : 2,
  //   status: 1
  // })
  const paths = services.map(item => ({
    params: {
      slug: item.slug, 
      locale: item.lang === 1 ? "vi" : "en" 
    }
  }))
  return {
    paths,
    fallback: true
  }
}

export const getStaticProps = async ({params, locale}) => {
  return {
    props: { 
      service : findService(params.slug),
      localeServer: locale,
    },
  }
}

export default ServiceDetail;
